export default "__VITE_PUBLIC_ASSET__7c27d941__"